<template>
  <!-- 产品体系 -->
  <div class="system">
    <div class="header">
      <div class="title">产品体系</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <router-link class="item" v-for="item in systemList" :key="item.id" :to="item.path">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilesystem1 from "../../../assets/home/mobilesystem1.png";
import mobilesystem2 from "../../../assets/home/mobilesystem2.png";
import mobilesystem3 from "../../../assets/home/mobilesystem3.png";
import mobilesystem4 from "../../../assets/home/mobilesystem4.png";
import mobilesystem5 from "../../../assets/home/mobilesystem5.png";
import mobilesystem6 from "../../../assets/home/mobilesystem6.png";

export default {
  setup() {
    return reactive({
      systemList: [
        {
          id: 1,
          title: "畅月数字家园管理系统",
          text: "物业全面数字化智能管理，帮助企业降本增效",
          logo: mobilesystem1,
          path: "/mobile/product/adminsystem"
        },
        {
          id: 2,
          title: "物联网平台",
          text: "多样化硬件对接，整合硬件设备，打破设备信息孤岛，实现智能互联",
          logo: mobilesystem2,
          path: "/mobile/product/things"
        },
        {
          id: 3,
          title: "智慧社区",
          text: "便利的社区增值服务，丰富社区生活的同时提升用户幸福感",
          logo: mobilesystem3,
          path: "/mobile/programme/community"
        },
        {
          id: 4,
          title: "物业APP",
          text: "企业信息化移动办公助手，物业管理更方便、更快捷、更高效",
          logo: mobilesystem4,
          path: "/mobile/product/property"
        },
        {
          id: 5,
          title: "业主APP、小程序",
          text: "APP+小程序全面实现移动办公，物业工作随时处理，效率更高更便捷",
          logo: mobilesystem5,
          path: "/mobile/product/resident"
        },
        {
          id: 6,
          title: "物业工单系统",
          text: "建立企业标准化协作流程，帮助企业高效快速办公",
          logo: mobilesystem6,
          path: "/mobile/product/workorder"
        }
      ]
    });
  }
};
</script>

<style scoped>
.system {
  width: 92vw;
  margin: 24px auto 0;
  text-align: center;
}
.header {
  width: 100%;
  margin: 0 auto;
}
.header .title {
  font-size: 16px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 5px auto 0;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}
.body .list .item {
  width: 165px;
  height: 160px;
  background-image: url(../../../assets/home/systemBack.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  margin-bottom: 12px;
  color: #3d3d3d;
}
.body .list .item img {
  width: 38px;
  margin-top: 20px;
}
.body .list .item .title {
  font-size: 14px;
  margin-top: 8px;
  font-weight: 600;
}
.body .list .item .text {
  width: 149px;
  margin: 8px auto 0;
  font-size: 10px;
  color: #495a6c !important;
}
</style>
